import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import {
  DISCOUNT_CODE_CREATE_MUTATION,
  DISCOUNT_CODE_DELETE_MUTATION,
  DISCOUNT_CODE_UPDATE_MUTATION,
} from "./mutations";
import {
  DiscountCodeCreate,
  DiscountCodeCreateVariables,
  DiscountCodeDelete,
  DiscountCodeDeleteVariables,
  DiscountCodeUpdate,
  DiscountCodeUpdateVariables,
} from "./__generated__/mutations";
import { DISCOUNT_CODES_QUERY, DISCOUNT_CODE_QUERY } from "./queries";
import {
  DiscountCodes,
  DiscountCodesVariables,
  DiscountCodeQuery,
  DiscountCodeQueryVariables,
} from "./__generated__/queries";

export const useDiscountCodeCreateMutation = makeMutationHook<
  DiscountCodeCreate,
  DiscountCodeCreateVariables
>(DISCOUNT_CODE_CREATE_MUTATION);

export const useDiscountCodeUpdateMutation = makeMutationHook<
  DiscountCodeUpdate,
  DiscountCodeUpdateVariables
>(DISCOUNT_CODE_UPDATE_MUTATION);

export const useDiscountCodeDeleteMutation = makeMutationHook<
  DiscountCodeDelete,
  DiscountCodeDeleteVariables
>(DISCOUNT_CODE_DELETE_MUTATION);

export const useDiscountCodesQuery = makeQueryHook<
  DiscountCodes,
  DiscountCodesVariables
>(DISCOUNT_CODES_QUERY);

export const useDiscountCodeQuery = makeQueryHook<
  DiscountCodeQuery,
  DiscountCodeQueryVariables
>(DISCOUNT_CODE_QUERY);
